<template lang="pug">
  div.container
    el-form(:model="model" label-position="top" label-width="12em")
      vue-form-generator(
        :schema="schema",
        :model="model",
        :options="formOptions"
        ref="form"
      )
</template>
<script>

import { component as VueFormGenerator } from 'vue-form-generator'
import { schemas } from './schemas'

export default {
  components: {
    VueFormGenerator
  },

  props: {
    despacho: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      default: 'CERTIDAO_TITULO'
    }
  },

  data () {
    return {
      model: {},
      schema: {},
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateBeforeSave: true,
        despacho: null,
        //  tipoModelo 3 corresponde à modelos de Título
        tipoModelo: 5
      }
    }
  },

  async mounted () {
    this.schema = schemas.emissao_titulo[this.tipo]
    this.formOptions.despacho = {
      idProcesso: this.despacho.processo?.id,
      tipo: this.despacho.tipo,
      perfil: this.despacho.perfil
    }
    this.montarCertidao()
  },

  methods: {
    save () {
      if (this.formOptions.validateBeforeSave === false || this.validate()) {
        return this.salvarDespacho()
      } else {
        return undefined
      }
    },

    salvarDespacho () {
      let despacho = this.despacho
      despacho.tituloDespacho.tituloProcessoDTO = {
        textoCertidao: this.model.textoCertidao !== null ? this.model.textoCertidao.replace(/<br>/g, '<br/>') : '',
        numeroDaCertidao: this.model.numeroDaCertidao,
        numeroFolha: this.model.numeroFolha,
        numeroLivro: this.model.numeroLivro,
        dataEmissao: new Date()
      }
      return despacho
    },

    validate () {
      return this.$refs.form.validate()
    },

    onValidate: function ($event) {
      this.$refs.vfg.validate()
    },

    montarCertidao () {
      if (this.despacho.tituloDespacho && this.despacho.tituloDespacho.tituloProcessoDTO) {
        this.model = {
          isCertidao: true,
          numeroLivro: process.env.ESTADO === 'ma' ? this?.despacho?.tituloDespacho?.tituloProcessoDTO?.numeroLivro : (new Date().getFullYear() - 2002),
          textoCertidao: this?.despacho?.tituloDespacho?.tituloProcessoDTO?.textoCertidao || '',
          numeroDaCertidao: this?.despacho?.tituloDespacho?.tituloProcessoDTO?.numeroDaCertidao,
          numeroFolha: this?.despacho?.tituloDespacho?.tituloProcessoDTO?.numeroFolha
        }
      } else {
        this.model = {
          isCertidao: true,
          numeroLivro: (new Date().getFullYear() - 2002)
        }
      }
    }
  }
}

</script>
<style lang="scss">
@import "@/assets/styles/_variables.scss";

.none {
  border: none;
}
.el-form-item__content {
  text-align: left;
}

.el-form-item__content .el-select {
  width: 100%;
}

.el-form-item__label {
  color: $font-dark-color;
  font-size: 14px;
  font-weight: bold;
}

.el-form-item__label::after {
  content: "*";
  color: firebrick;
  font-size: 14px;
  font-weight: bold;
}

.error {
  .field-wrap {
    .el-form-item {
      .el-form-item__content {
        border: 1px solid firebrick;
        border-radius: 4px;
        border-color: firebrick;
        -webkit-box-shadow: inset 0 1px 2px #ff867c , 0 0 9px firebrick;
        box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
      }
    }
  }
}

.erro {
  border: 1px solid firebrick;
  border-radius: 4px;
  border-color: firebrick;
  -webkit-box-shadow: inset 0 1px 2px #ff867c , 0 0 9px firebrick;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}

.help-block {
  color: firebrick;
}

.app-container {
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  width: 50%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppFormularioCertidao.vue